import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const UserContactServices = createApi({
	reducerPath: "contact",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api",
	}),
	endpoints: (builder) => {
		return {
			userContact: builder.mutation({
				query: (ContactData) => {
					return {
						url: "/contact-us/store",
						method: "POST",
						body: ContactData,
					};
				},
			}),
		};
	},
});
export const { useUserContactMutation } = UserContactServices;
export default UserContactServices;
